<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="adjustmentReasonTypeData === null"
        >Create Adjustment Reason Type</span
      >
      <span v-else>Update Adjustment Reason Type</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Membership Program" required>
              <a-select
                v-model="formData.membership_program_id"
                :disabled="viewMode || adjustmentReasonTypeData !== null"
              >
                <a-select-option
                  v-for="membershipProgram in membershipPrograms"
                  :key="membershipProgram.id"
                  :value="membershipProgram.id"
                >
                  {{ membershipProgram.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.membership_program_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.membership_program_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Category">
              <a-select v-model="formData.category" :disabled="viewMode">
                <a-select-option value="POINTS">
                  Points Adjustment
                </a-select-option>
                <a-select-option
                  v-if="hasCardSellingModule"
                  value="CARD_SELLING"
                >
                  Card Selling Adjustment
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Status">
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="I"> Inactive </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Description">
              <a-textarea
                v-model="formData.description"
                :auto-size="{ minRows: 3, maxRows: 3 }"
                :disabled="viewMode"
            /></base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="adjustmentReasonTypeData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createAdjustmentReasonType"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmUpdate"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'AdjustmentReasonTypeForm',
  props: {
    adjustmentReasonTypeData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      hasCardSellingModule: false,
      formData: {
        membership_program_id: null,
        name: null,
        description: null,
        category: 'POINTS',
        status: 'A'
      },
      membershipPrograms: []
    };
  },
  validations: {
    formData: {
      membership_program_id: {
        required
      },
      name: { required }
    }
  },
  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getCardSellingFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_SELLING_FEATURE`
      );

      if (response.account_id) {
        this.hasCardSellingModule = response.value == 'true';
      }
    },
    async createAdjustmentReasonType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_adjustment_reason_types',
          {
            adjustment_reason_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
        this.formSubmitting = false;
      }
    },
    async editAdjustmentReasonType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_adjustment_reason_types/' +
            this.adjustmentReasonTypeData.id,
          {
            adjustment_reason_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editAdjustmentReasonType();
        }
      });
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        membership_program_id: null,
        name: null,
        description: null,
        category: 'POINTS',
        status: 'A'
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        const { membership_program_id, name, description, category, status } =
          data;

        this.formData = {
          membership_program_id,
          name,
          description,
          category,
          status
        };
      } else {
        this.clearForm();
      }
    }
  },
  created() {
    this.getMembershipPrograms();
    this.getCardSellingFeature();
    this.setFormData(this.adjustmentReasonTypeData);
  },
  watch: {
    adjustmentReasonTypeData: function (data) {
      this.setFormData(data);
    },
    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  }
};
</script>

<style scoped></style>
